<template>
	<v-dialog 
		v-model="open"
		fullscreen
		persistent
		transition="dialog-bottom-transition"
		style="overflow-x: hidden"
		scrollable>
		<v-card class="background-1 rounded-0" v-if="open">
			<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3">Invio massivo {{ $trans(infoFieldsset.modelDef) }}</p>
				<v-spacer></v-spacer>
				<v-btn icon @click.native.stop="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
			</v-card-title>
			<v-divider></v-divider>
			
			<v-card-text style="overflow-x: hidden" class="pa-0">

				<v-container class="px-6" fluid>
					<v-row class="mx-0">
						<v-col cols="12" class="display-flex px-1 pt-6 pb-0">
							<strong>Filtri</strong>
						</v-col>
					</v-row>
					<v-card class="round-card background-2 pa-4 px-0 mt-6 pt-12">
						<fields-generator
							v-if="loaded"
							:fieldsset.sync="infoFieldsset"
							:model.sync="filters"
							ref="fieldsgenerator"
						></fields-generator>
					</v-card>
				</v-container>

				<v-container class="px-6" fluid>
					<v-row class="mx-0">
						<v-col cols="12" class="display-flex px-1 pt-6 pb-0">
							<strong>Documenti Selezionati</strong>
							<span class="grey--text pr-4">&nbsp;({{ documents.length }})</span>

							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<div v-on="on" class="display-flex">
										<v-icon color="success" class="">mdi-email</v-icon>
										<span class="grey--text pr-4">&nbsp;({{ countMailsCorrect }})</span>
									</div>
								</template>
								<span>Indirizzi corretti</span>
							</v-tooltip>
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<div v-on="on" class="display-flex">
										<v-icon color="error" class="">mdi-email</v-icon>
										<span class="grey--text pr-4">&nbsp;({{ countMailsErrors }})</span>
									</div>
								</template>
								<span>Indirizzi mancanti</span>
							</v-tooltip>
						</v-col>
					</v-row>
				</v-container>

				<v-container class="px-6" fluid>
					<v-card class="round-card background-2 pa-4">
						<v-row class="mx-0 py-2">
							<v-col class="pa-0" cols="12" sm="12" md="6" lg="3" v-for="(document, key, i) in documents" :key="i">
								<v-list two-line dense class="background-2 w100p py-0">
									<v-list-item @click="openNewTab(document.id)" @click.middle="openNewTab(document.id)">
										<v-list-item-action>
											<v-icon :color="checkEmail(document.email_to_send) ? 'success' : 'error'">mdi-email</v-icon>
										</v-list-item-action>
										<v-list-item-content>
											<v-list-item-title style="font-size: 12px !important">{{ document.name }}</v-list-item-title>
											<v-list-item-subtitle>{{ document.email_to_send }}</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-col>
						</v-row>
					</v-card>
					<small class="pl-2">Se l'indirizzo email risulta mancante il documento non sarà inviato.</small>
				</v-container>		
	

				<v-container class="px-6" fluid>
					<v-row class="mx-0">
						<v-col cols="12" class="display-flex px-1 pt-6 pb-0">
							<strong>Impostazioni Email</strong>
						</v-col>
					</v-row>
					<v-card class="round-card background-2 pa-4 mt-6 pt-12">
						<v-container class="pt-0" fluid v-if="loaded">
							<v-row class="ma-0 pb-3 pa-4 pt-0">
								<v-col class="py-0" cols="12" lg="6">
									<v-combobox
										name="from"
										label="Da*"
										small-chips
										combobox
										clearable
										required
										v-model="model['from']"
										:error-messages="errors.collect('Da')"
										v-validate="'email|required'"
										:data-vv-name="'Da'"
										outlined
										dense
									></v-combobox>
								</v-col>
								<v-col class="py-0" cols="12" lg="6">
									<v-combobox
										label="Nome Mittente"
										small-chips
										combobox                                
										clearable
										v-model="model['fromName']"
										color="primary"
										outlined
										dense>
									</v-combobox>
								</v-col>
								<v-col class="py-0" cols="6" >
									<v-text-field
										name="subject"
										label="Oggetto*"
										v-model="model['subject']"
										:error-messages="errors.collect('Oggetto')"
										required
										v-validate="'required'"
										:data-vv-name="'Oggetto'"
										outlined
										dense
									></v-text-field>
								</v-col>
								<v-col class="py-0" cols="6">
									<v-select
										:items="templates"
										label="Template Mail"
										hint="Seleziona il template da inserite nella mail"
										:required="false"
										v-model="model['template_default_id']"
										:menu-props="{'offset-y': true}"
										return-object
										dense
										@change="setTemplateInTextEditor($event)"
										outlined>
										<template v-slot:item="data">
											<template>
												<v-list-item-avatar
													size="32px"
													style="min-width: 32px; width: 32px; height:32px; border-radius: 50%"
													class="primary mr-4">
													<v-icon class="fs18i" color="white">mail</v-icon>
												</v-list-item-avatar>
												<v-list-item-content>
													<v-list-item-title>{{ data.item.text }}</v-list-item-title>
													<v-list-item-subtitle>
														<span v-for="(key, k) in ['subtitle']" :key="k">{{$trans(data.item[key])}}&nbsp;
														</span>
													</v-list-item-subtitle>
												</v-list-item-content>
											</template>
										</template>
									</v-select>
								</v-col>
								<v-col class="py-0" cols="6" >
									<v-select
										:items="model.signatures" 
										label="Firma"
										hint="Seleziona una firma da inserite nella mail"
										:required="false"
										v-model="signatureSelected"
										:menu-props="{'offset-y': true}"
										return-object
										dense
										outlined>
										<template v-slot:item="data">
											<template>
												<v-list-item-avatar
													size="32px"
													style="min-width: 32px; width: 32px; height:32px; border-radius: 50%"
													class="primary mr-4">
													<v-icon class="fs18i" color="white">draw</v-icon>
												</v-list-item-avatar>
												<v-list-item-content>
													<v-list-item-title>{{ data.item.text }}</v-list-item-title>
													<v-list-item-subtitle>
														<span v-for="(key, k) in ['subtitle']" :key="k">{{$trans(data.item[key])}}&nbsp;
														</span>
													</v-list-item-subtitle>
												</v-list-item-content>
											</template>
										</template>
									</v-select>
								</v-col>
								<v-col class="py-0" cols="6" v-if="model.attachmentIncluded != undefined">
									<v-switch
										v-model="model['attachmentIncluded']"
										hide-details
										inset
										label="Includi allegato documento"
										color="primary"
										class="margin-auto">
									</v-switch>
								</v-col>
								<v-col class="py-0 d-block" cols="12">
									<tinymce-editor
										v-if="$store.getters.checkSettings('use_tinymce_editor')"
										editor-id="quill"
										v-model="model['body']"
										ref="tinymceEditor"
									/>
									<vue-editor v-else
										id="quill"
										v-model="model['body']"
										ref="editor"
									></vue-editor>
									<v-col class="px-4 d-block text-center" cols="12" v-if="model.email_variables">
										<v-chip v-for="(value, key, i) in model.email_variables.variables" outlined color="primary" class="ma-1" text-color="primary" @click="setTemplateVariable(value)" :key="i">
												{{ value }}
											<v-icon right>library_books</v-icon>
										</v-chip>
									</v-col>
								</v-col>
							</v-row>
						</v-container>
					</v-card>
				</v-container>

			</v-card-text>

			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="info" @click.native="$emit('close')">Annulla</v-btn>
				<v-btn text color="primary" @click.native="validateFields()" :loading="sending">Procedi</v-btn>
			</v-card-actions>
		</v-card>

		<confirm-dialog
		    :confirmModel="confirmSendMail"
		    mainTitle="Sei sicuro di inviare queste mail?"
		    secondTitle="Una volta premuto 'Invia' le mail saranno aggiunte a una coda di invio, potrai seguire il loro stato dai Mail Log e all'apertura del messaggio da parte del cliente riceverai una notifica"
		    @update:confirmModel="confirmSendMail = false"
		    :atConfirm="sendMails"
			:confirm="{color: 'info', label: 'invia'}"
		></confirm-dialog>
	</v-dialog>
</template>

<script>
	import MailTemplateMixin from '@/mixins/MailTemplateMixin'

	export default {
		name: 'send-multiple-mails',
		mixins: [MailTemplateMixin],
		props: {
			params: Object,
			selected: Array,
			selectedIds: Array,
			modelDef: String,
			open: Boolean,
			button: Object,
		},
		
		data() {
			return {
				documents: [],
				infoFieldsset: [],
				model: {},
				filters: {},
				ids: [],
				sending: false,
				loading: false,
				loaded: false,
				confirmSendMail: false,
				templates: [],
				signatures: [],
				signatureSelected: {},
				templateSelected: {},
				isInitializing: true, // Used by the mixin to prevent watcher during initialization
			}
		},

		watch: {
			open: {
				handler(newValue, oldValue) {
					if(newValue) {
						this.getInfo()
					}
				}
			},
			
			filters: {
				handler() {
					this.getData()
				},
				deep: true
			},
			
			// Add specific watcher for signatureSelected to match SendMail.vue
			signatureSelected: {
				handler(newVal, oldVal) {
					// Only run this if we're not in initialization mode
					if (this.isInitializing) return
					
					// If no template was selected (check templateSelected instead of default_template)
					if (!this.templateSelected || !this.templateSelected.body) {
						// Get signature content
						const signatureContent = newVal && newVal.body ? newVal.body : ''
						
						// Get current body content (could be empty)
						let currentBody = this.model.body || ''
						
						// Remove old signature if exists
						if (oldVal && oldVal.body) {
							// Check for different signature separator patterns
							const separatorPatterns = [
								'<p><br></p><p>--</p>' + oldVal.body,
								'<p>--</p>' + oldVal.body,
								'<p><br></p>' + oldVal.body,
								oldVal.body
							]
							
							// Try to remove the old signature with its separator
							for (const pattern of separatorPatterns) {
								if (currentBody.endsWith(pattern)) {
									currentBody = currentBody.substring(0, currentBody.length - pattern.length)
									break
								}
							}
						}
						
						// Add new signature if available
						if (signatureContent) {
							// Check if signature already has a separator
							const startsWithSeparator = signatureContent.startsWith('<p>--</p>')
							
							// Use appropriate separator based on signature format
							const separator = startsWithSeparator ? '<p><br></p>' : '<p><br></p><p>--</p>'
							
							// Only add separator if there's content already
							if (currentBody.trim()) {
								currentBody += separator
							}
							
							currentBody += signatureContent
						}
						
						// Update model body
						this.model.body = currentBody
					}
				},
				deep: true
			}
		},
		
		methods: {

			getData() {
				this.axios.post('send-mulitple-emails-data/', {ids: this.selectedIds, model: this.button.model, filters: this.filters}).then(response => {
					// get body data
					this.$set(this, 'documents', response.data.data)

				}, response => {
					// error callback
				})				
			},
			
			getInfo() {
				this.axios.post('send-mulitple-emails-info/', {'model': this.button.model}).then(response => {
					// get body data
					this.infoFieldsset = response.data.fields.filters;
					this.model = response.data.fields.email;
					this.templates = response.data.fields.email.template_mail || [];
					
					if (this.model['attachmentIncluded']) {
						this.model['attachmentIncluded'] = true;
					}
					
					// Get default template and signature with null checks
					this.signatureSelected = this.templates.length > 0 ? this.selectDefaultItem(
						this.model.signature_default_id, 
						this.model.signatures || [], 
						(this.model.signatures && this.model.signatures.length > 0) ? this.model.signatures[0] : null
					) : null;
					
					this.templateSelected = this.templates.length > 0 ? this.selectDefaultItem(
						this.model.template_default_id, 
						this.templates, 
						this.templates.length > 0 ? this.templates[0] : null
					) : null;
					
					// Only set template_default_id if templateSelected exists and has a value property
					if (this.templateSelected && this.templateSelected.value !== undefined) {
						this.$set(this.model, 'template_default_id', this.templateSelected.value);
					}
					
					// Initialize email content using the mixin method - with null checks
					this.initializeEmailContent(
						this.templateSelected || { body: '' }, 
						this.signatureSelected || { body: '' }
					);
					
					// Setup filters
					_.forEach(this.infoFieldsset.fields, (value, key) => {
						if (value.type === 'checkbox') {
							this.$set(this.filters, value.key, '');
						}
						if (value.default) {
							this.$set(this.filters, value.key, value.default);
						}
					});

					_.forEach(this.defaultInput, (value, key) => {
						this.$set(this.filters, key, value);
					});

					this.loaded = true;
					this.getData();
				});
			},

			openNewTab(id) {
				let showRoute = this.modelDef + '-show'
				 if (this.modelDef.startsWith('documents')) {
					showRoute = 'documents-show'
				}
				
				const url = this.$router.resolve({ name: showRoute, params: { id: parseInt(id), ...this.params }}).href
				window.open(url, '_blank')
			},
			
			checkEmail(email) {
				if(email === undefined || email == null || email === '') {
					return false
				} else {
					return true
				}
			},

			sendMails() {
				this.sending = true

				let dataObject = {
					model: this.button.model,
					email: this.model,
					filters: this.filters,
					ids: this.documents.map((document) => {
						return document.id
					})
				}

				this.axios.post('send-mulitple-emails', dataObject).then(response => {
					// get body data
					this.sending = false

					this.$store.commit('setSnackbar', {timeout: 6000, text: response.data.message, value: true, color: response.data.status})

					this.$emit('close')
				}, response => {
					// error callback
				})
				// Reset the isInitializing flag after sending mails
				this.isInitializing = false;
			},

		},

		computed: {
			countMailsErrors() {
				if(this.documents) {
					let count = 0
					_.forEach(this.documents, (document, key) => {
						if(document.email_to_send === undefined || document.email_to_send == null || document.email_to_send === '') {
							count++
						}
					})
					return count
				} else {
					return 0
				}
			},

			countMailsCorrect() {
				return this.documents.length - this.countMailsErrors
			}
		},

	}
</script>
